import "../utils/staleChunkReload"

require("../utils/startRailsUjs")
require("../src/application/setup")

import "../stylesheets/application.css.sass"
import ReactOnRails from "react-on-rails"

import { wrapWithErrorBoundary } from "../@core/HoneyBadgerErrorBoundary"
import BlogIndexPage from "../pages/Blog/BlogIndexPage"
import BlogPostPage from "../pages/Blog/BlogPostPage"
import WebsiteBuilderV2PublicPage from "../pages/WebsiteBuilderV2/WebsiteBuilderV2PublicPage"

const components = {
  WebsiteBuilderV2PublicPage,
  BlogIndexPage,
  BlogPostPage
}

Object.entries(components).forEach(([name, Component]) => {
  ReactOnRails.register({
    [name]: wrapWithErrorBoundary(Component)
  })
})
